// Shared report exporters: CSV, Excel (.xlsx) and PDF.
// rows = array of plain objects (keys become column headers).
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

// --- CSV (kept for places that still want a quick CSV) ---
export function exportCsv(filename, rows) {
  if (!rows || !rows.length) return false;
  const headers = Object.keys(rows[0]);
  const esc = (v) => `"${String(v == null ? '' : v).replace(/"/g, '""')}"`;
  const csv = [headers.join(','), ...rows.map((r) => headers.map((h) => esc(r[h])).join(','))].join('\n');
  const blob = new Blob(['\ufeff' + csv], { type: 'text/csv;charset=utf-8;' });
  triggerDownload(blob, filename.endsWith('.csv') ? filename : `${filename}.csv`);
  return true;
}

// --- Excel (.xlsx) ---
export function exportExcel(filename, rows, sheetName = 'Report') {
  if (!rows || !rows.length) return false;
  const ws = XLSX.utils.json_to_sheet(rows);
  // Auto-ish column widths based on header + cell length.
  const headers = Object.keys(rows[0]);
  ws['!cols'] = headers.map((h) => {
    const maxLen = Math.max(h.length, ...rows.map((r) => String(r[h] == null ? '' : r[h]).length));
    return { wch: Math.min(60, Math.max(10, maxLen + 2)) };
  });
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, sheetName);
  XLSX.writeFile(wb, filename.endsWith('.xlsx') ? filename : `${filename}.xlsx`);
  return true;
}

// --- PDF ---
// title: heading line; subtitle: optional second line (e.g. period / client name)
export function exportPdf(filename, rows, { title = 'Report', subtitle = '' } = {}) {
  if (!rows || !rows.length) return false;
  const doc = new jsPDF({ orientation: 'landscape', unit: 'pt', format: 'a4' });
  const headers = Object.keys(rows[0]);
  doc.setFontSize(16);
  doc.text(title, 40, 40);
  if (subtitle) {
    doc.setFontSize(10);
    doc.setTextColor(110);
    doc.text(subtitle, 40, 58);
    doc.setTextColor(0);
  }
  autoTable(doc, {
    startY: subtitle ? 72 : 56,
    head: [headers],
    body: rows.map((r) => headers.map((h) => (r[h] == null ? '' : String(r[h])))),
    styles: { fontSize: 9, cellPadding: 4, overflow: 'linebreak' },
    headStyles: { fillColor: [102, 126, 234], textColor: 255 },
    alternateRowStyles: { fillColor: [245, 246, 250] },
    margin: { left: 40, right: 40 },
  });
  doc.save(filename.endsWith('.pdf') ? filename : `${filename}.pdf`);
  return true;
}

function triggerDownload(blob, filename) {
  const a = document.createElement('a');
  a.href = URL.createObjectURL(blob);
  a.download = filename;
  a.click();
  URL.revokeObjectURL(a.href);
}
